import { render, staticRenderFns } from "./CreateImage.vue?vue&type=template&id=2735adc3&scoped=true"
import script from "./CreateImage.vue?vue&type=script&lang=js"
export * from "./CreateImage.vue?vue&type=script&lang=js"
import style0 from "./CreateImage.vue?vue&type=style&index=0&id=2735adc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735adc3",
  null
  
)

export default component.exports